// import Colors from '../../../Configs/colors';

const styles = {
  root: {
    padding: '16px 0',
    minWidth: 320,
  },
};

export default styles;
